import { render, staticRenderFns } from "./weddings.vue?vue&type=template&id=689ed3d0&"
import script from "./weddings.vue?vue&type=script&lang=js&"
export * from "./weddings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports